export default {
  items: [
    {
      name: 'Inicio',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: ''
      }
    },
    {
      name: 'Eventos',
      url: '/eventos',
      icon: 'cui-star',
    },
    {
      name: 'Sorteos Globales',
      url: '/sorteos-globales',
      icon: 'cui-star',
    },
    {
      name: 'Staff',
      url: '/staff',
      icon: 'cui-people',
    },
    {
      name: 'EDI',
      url: '/edi',
      icon: 'icon-star',
      children: [
        {
          name: 'Transferencias',
          url: '/edi/transferencias',
          icon: 'icon-star',
          children: [
            {
              name: 'Import',
              url: '/edi/transferencias/import',
              icon: 'icon-star'
            },
            {
              name: 'Export',
              url: '/edi/transferencias/export',
              icon: 'icon-star'
            },
          ]    
        },
      ]
    },
    {
      name: 'Tablas',
      url: '/tablas',
      icon: 'icon-star',
      children: [
        {
          name: 'Clientes',
          url: '/tablas/clientes',
          icon: 'icon-star'
        },
        {
          name: 'Bancos',
          url: '/tablas/bancos',
          icon: 'icon-star'
        },
      ]
    },
    {
      name: 'Seguridad',
      url: '/seguridad',
      icon: 'icon-star',
      children: [
        {
          name: 'Usuarios',
          url: '/seguridad/usuarios',
          icon: 'cui-people'
        },
        {
          name: 'Usuario PWA',
          url: '/seguridad/pwa',
          icon: 'cui-people'
        },
        {
          name: 'Credenciales Veraz',
          url: '/seguridad/veraz',
          icon: 'cui-people'
        },
      ]
    },
  ]
}
